import * as constants from 'common/constants';

export const show = (id, message, isError) => ({
  type: constants.BANNER_SHOW,
  payload: { id, message, isError },
});

export const hide = id => ({ type: constants.BANNER_HIDE, payload: { id } });

/**
 * Default action to use when displaing an informational banner. Automatically
 * hides the banner after a set time.
 *
 * @param {string} id - One of constants.BANNER_IDS
 * @param {string} message - The text to display in the banner
 * @param {boolean} isError - Whether to show a success checkmark beside the text
 * @param {number} duration - How long to show the banner in ms (default: 4000) 4 sec from requirement
 */
export const display = (
  id,
  message,
  isError = false,
  duration = 4000
) => dispatch => {
  dispatch(show(id, message, isError));
  setTimeout(() => dispatch(hide(id)), duration);
};



// WEBPACK FOOTER //
// ./src/actions/banner.js